"use client";

import type { LucideIcon } from "lucide-react";

interface ClickableLocationInfoProps {
  icon: LucideIcon;
  label: string;
  children: React.ReactNode;
}

export function ClickableLocationInfo({
  icon: Icon,
  label,
  children,
}: ClickableLocationInfoProps) {
  const handleClick = () => {
    const mapSection = document.getElementById("map-section");
    if (mapSection) {
      mapSection.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      className="grid grid-cols-[auto_1fr] gap-5 items-center cursor-pointer hover:opacity-80 transition-opacity"
    >
      <Icon className="h-5 w-5 text-foreground" />
      <div className="flex flex-col gap-1">
        <p className="font-medium">{label}</p>
        <div className="text-foreground font-normal">{children}</div>
      </div>
    </div>
  );
}
